import { useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function Login({ onLogin }) {
  const [token, setToken] = useState('');
  const [apiUrl, setApiUrl] = useState('https://mantis.gmed.it/api/rest');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        token,
        api_url: apiUrl,
      });

      toast.success('Login effettuato con successo!');
      onLogin(response.data.token, response.data.api_url);
    } catch (error) {
      toast.error('Login fallito. Verifica il token e l\'URL API.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[rgb(9,9,11)] p-4">
      <div className="w-full max-w-md">
        <div className="border border-[rgb(39,39,42)] bg-[rgb(24,24,27)]/50 backdrop-blur-sm p-8 rounded-md">
          <div className="mb-8 text-center">
            <img 
              src="/assets/logo_gmed.svg" 
              alt="Gmed Logo" 
              className="h-16 mx-auto mb-4"
              data-testid="gmed-logo"
            />
            <h1 className="text-3xl font-bold font-mono mb-2 text-gradient" data-testid="login-title">
              MantisBT BI
            </h1>
            <p className="text-[rgb(161,161,170)] text-sm font-mono uppercase tracking-widest">
              Control Room Dashboard
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="api-url" className="text-[rgb(161,161,170)] text-xs uppercase tracking-widest font-mono">
                API URL
              </Label>
              <Input
                id="api-url"
                data-testid="api-url-input"
                type="text"
                value={apiUrl}
                onChange={(e) => setApiUrl(e.target.value)}
                placeholder="https://mantis.gmed.it/api/rest"
                className="bg-black/20 border-[rgb(39,39,42)] focus:border-[rgb(59,130,246)] focus:ring-1 focus:ring-[rgb(59,130,246)] font-mono text-sm"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="token" className="text-[rgb(161,161,170)] text-xs uppercase tracking-widest font-mono">
                Token API
              </Label>
              <Input
                id="token"
                data-testid="token-input"
                type="password"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Inserisci il tuo token MantisBT"
                className="bg-black/20 border-[rgb(39,39,42)] focus:border-[rgb(59,130,246)] focus:ring-1 focus:ring-[rgb(59,130,246)] font-mono text-sm"
                required
              />
            </div>

            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full bg-[rgb(59,130,246)] text-white hover:bg-[rgb(59,130,246)]/90 rounded-md font-mono glow-primary"
            >
              {loading ? 'Accesso in corso...' : 'Accedi'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;